<script>
import DibbleJs from "@/dibble";
import DibbleApi from "@/api";
import PublicWidgetDonation
    from "@/components/widgets/components/public-view/PublicWidgetDonation.vue";
import PublicWidgetSupporter
    from "@/components/widgets/components/public-view/PublicWidgetSupporter.vue";
import PublicWidgetGoalMeter
    from "@/components/widgets/components/public-view/PublicWidgetGoalMeter.vue";

export default {
    name: 'WidgetPublicView',
    components: {
        PublicWidgetGoalMeter,
        PublicWidgetSupporter, PublicWidgetDonation},
    created() {
        this.getWidget();
    },
    data() {
        return {
            widgetId: this.$route.params.id,
            error: false,
            widgetData: {},
            msg: 'Widget Public View'
        }
    },
    watch: {
        widgetData: function (val) {
            console.log('data changed: ', val)
        }
    },
    methods: {
        getWidget() {
            const data = {
                '#request': DibbleApi.api.viewerGetWidget,
                widget_id: this.widgetId,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.widgetData = response;
                } else {
                    this.error = true;
                }
            });
        }
    },
}
</script>

<template>
    <div>
        <div v-if="widgetId && !error">
            <div v-if="widgetData">
                <PublicWidgetDonation :data="widgetData" v-if="widgetData.type === 1" />
                <PublicWidgetSupporter :data="widgetData" v-if="widgetData.type === 2" />
                <PublicWidgetGoalMeter :data="widgetData" v-if="widgetData.type === 3" />
            </div>
        </div>
        <div v-else>
            <h1>Widget not found</h1>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
